import useReduxCase from 'modules/cm/hooks/useCurrentCaseStore';

export const useIsPepperSend = () => {
  const currentCaseStore = useReduxCase();
  const currentCaseData = currentCaseStore.readonlyFields;
  const isPepperSend = currentCaseData.admin.pepperUploadDate;
  return isPepperSend !== null;
};

export default useIsPepperSend;
